import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import {
  clearPublicationDateTime,
  clearPublishingDelayData,
  clearRecurrenceData,
} from "../../../redux/slices/lomavisCreator/lomavisCreator";
import { useTranslate } from "@tolgee/react";
import { VIEW_STATUS } from "../config/constants";
import { ALL } from "../../../config/constants";

const PlanningConfirmation = ({
  handleClose,
  handleShow,
  show,
  setModalToggle,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  return (
    <div>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("planning.confirmation.header")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("planning.confirmation.body")}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              dispatch(clearRecurrenceData({}));
              dispatch(clearPublishingDelayData({}));

              dispatch(clearPublicationDateTime({ platform: ALL }));

              setModalToggle();
              handleClose();
            }}
            variant="secondary"
            size="sm"
          >
            {t("cancel")}
          </Button>
          <Button
            size="sm"
            variant="primary"
            onClick={() => {
              handleClose();
            }}
          >
            {t("planning.confirmation.clear")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PlanningConfirmation;
